import React from "react";
import { Container, Col, Row } from "reactstrap";
import ListItem from "../UI-Card/ListItem";
import PortfolioNav from "../headerComponent/portfolioNav";
import { antelopeImages } from "../../data/images";

const Photography = () => {
  return (
    <Container className="photo-gallery">
      <Row>
        <Col xs="2" md="3" lg="4" />
        <Col xs="8" md="6" lg="4">
          <PortfolioNav />
        </Col>
        <Col xs="2" md="3" lg="4" />
      </Row>
      <Row>
        <Col>
          <h1>Photography</h1>
          <h2 className="my-2">Antelope Canyon</h2>
        </Col>
      </Row>
      <Row className="card-gallery">
        <Col className="four-columns">
          {antelopeImages.map(obj => (
            <ListItem key={obj.id} imageInfo={obj} />
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default Photography;
